import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/payments']['PUT'];

type Input = ThisApi['query'] & ThisApi['body'];
type Output = ThisApi['response'];

const searchPayments = async ({ page, perPage, ...body }: Input): Promise<Output> => {
  const response = await noodleApiClient.put('/payments', body, {
    params: { page, perPage },
  });
  return response.data;
};

export default searchPayments;
